import { Checkbox } from "@rmwc/checkbox";
import { useDispatch, useSelector } from "react-redux";
import EditPriceItem from "../../EditPriceItem/EditPriceItem.js";
import CurrencyFormat from "react-currency-format";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { extraItemsAction } from "../../../action/index.js";

const ExtraItemsWithoutQuantity = ({ isOldOverhang }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const isLTBuilding = useSelector((state) => state.reducer.const_var.isLTBuilding);
	const selectedLeanType = useSelector((state) => state.reducer.const_var.selectedLeanType);


	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();

	const twice = [const_var.a_p_d_a];

	const isRunningForAdditionalBuilding = isLTBuilding ? selectedLeanType !== "" : false;

	if (isRunningForAdditionalBuilding) {
		twice.unshift(JSON.parse(JSON.stringify(const_var.holdPricingResponse)));
	}

	return (
		<>
			{twice.map((a_p_d_a, mainIndex) => {
				return (
					<>
						{a_p_d_a.extra_items?.[0]?.checkbox?.map((val, index) => {
							if (isRunningForAdditionalBuilding) {
								const runningForDynamicOptions = mainIndex === 1;
								const runnignForCenterOnlyOptions = mainIndex === 0;

								if (runningForDynamicOptions) {
									if (val.name === "fourth_center_cost") {
										return null;
									}
								}

								if (runnignForCenterOnlyOptions) {
									if (val.name !== "fourth_center_cost") {
										return null;
									}
								}
							}

							let chkFlagForDistanceonCenter = false;
							let chkFlagForDistanceonCenterSBS = false;

							let isChecked;

							if(val.name == "fourth_center_cost") {
									if(const_var.isLTBuilding) {
										isChecked = !!const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding?.[index]?.is_checked
									} else {
										isChecked = !!const_var.ExtraItemsFeaturesArray?.[index]?.is_checked
									}
							}
							else {
								isChecked = !!const_var.ExtraItemsFeaturesArray?.[index]?.is_checked
							}


							if (isChecked != undefined) {
								if (params.isDefaultfourFeet == true && (val.name == "fourth_center_cost" || val.label == "4ft on Center")) {
									chkFlagForDistanceonCenter = true;
								}

								if (const_var.DistanceArr?.[params.p_b_t]?.[params.p_r_s] == 4) {
									if ((val.name == "fourth_center_cost" || val.label == "4ft on Center") && val.cost == 0) {
										chkFlagForDistanceonCenterSBS = true;
									}
								}
							}
							if (params.isDefaultfourFeet && (val.name == "fourth_center_cost" || val.label == "4ft on Center")) {
								chkFlagForDistanceonCenterSBS = false;
							}

							/*For old free standing builds*/
							let hideFourFeetOnCenter = false;
							let freeStandingCheck = const_var.editAPIDataByResponse?.data?.request_data?.building?.display_building_type_name === "Free Standing Buildings";
							let editMode = const_var.crmSetting?.is_Edit;
							let sameHeight = a_p_d_a?.building_structure?.[0]?.max_height == a_p_d_a?.building_structure?.[0]?.start_height;

							if (editMode && sameHeight && freeStandingCheck) {
								hideFourFeetOnCenter = true;
							}

							let elementPrice = const_var.UpdatedPriceData?.elements ?? [];

							if (const_var.isLTBuilding && val.name == "fourth_center_cost") {
								elementPrice = const_var.lNTBuildingData.updatePriceDataElements.centerBuilding ?? [];
							}

							return (
								<div
									className={
										(const_var.loginSession == false &&
										val.cost == 0 &&
										val.label != "fourth_center_cost" &&
										val.label != "4ft on Center" &&
										(val.name == "fourth_center_cost" || val.label == "4ft on Center") &&
										!val.is_checked)
											? "control-field-bar d-none"
											: "control-field-bar " + (val.name != "overhang" ? "" : " d-none")
										+ (((params.p_r_s != "1" && isOldOverhang == true) || val.name != "overhang") ? '' : ' d-none')
									}
								>
									<div className="control-field">
										<div className="check-group">
											<Checkbox
												checked={isChecked}
												label={val.label + (params.m_s_n == 147 && val.name == 'ground_certificate' ? ' (Up To 115 MPH Wind)' : '') + (chkFlagForDistanceonCenter?'(Included)': '')}
												disabled={hideFourFeetOnCenter ? true : params.isDefaultfourFeet && (val.name == "fourth_center_cost" || val.label == "4ft on Center")}
												onChange={(e) => dispatch(extraItemsAction(e.target.value, "extraitemsCheckbox", val, index))}
											/>

											{val.is_taxable == 1 && (
												<span className="control-label-type">
													{" "}
													(T<i>|</i>C){" "}
												</span>
											)}

											{val.name != "fourth_center_cost" && val.name != "overhang" ? (
												<OverlayTrigger
													trigger="hover"
													placement={window.innerWidth > 992 ? "left-start" : "bottom"}
													rootClose={true}
													overlay={
														<Popover className="popover-info popover-md">
															<Popover.Content>
																<div className="info-content">
																	<p>This item is not shown on the configurator, but gets added to your building design and may increase the price</p>
																</div>
															</Popover.Content>
														</Popover>
													}
												>
													<span className="control-info-tip">
														<i class="icon-eye-off"></i>
													</span>
												</OverlayTrigger>
											) : null}
										</div>
									</div>

									{isChecked && (
										<div className="control-field-action">
											{const_var.loginSession == true && (chkFlagForDistanceonCenter == false || chkFlagForDistanceonCenterSBS == true) ? (
												<div className="price-box">
													<EditPriceItem
														updatedPriceDataObj={val.name == "fourth_center_cost" && const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]}
														is_disabled={isChecked === true ? "false" : "true"}
														jsonObj={"extraitems"}
														jsonObjValue={isChecked}
														jsonObjKey={val.label}
														elementObjIndex={index}
														extraItemType={"extraitemsCheckbox"}
														priceKey={"ExtraItemsFeaturesArray"}
													/>
												</div>
											) : (
												<div className="price-box-type-2">
													{const_var.hide_price_calculation != 1 && const_var.loginSession == false && elementPrice?.[val.label]?.item_price !== 0 && (
														<CurrencyFormat value={elementPrice[val.label]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
													)}
												</div>
											)}
										</div>
									)}
								</div>
							);
						})}
					</>
				);
			})}
		</>
	);
};

export default ExtraItemsWithoutQuantity;
